// extracted by mini-css-extract-plugin
module.exports = {"registerSection":"Register_registerSection__3hLQx","loginSection":"Register_loginSection__D4i1n","textField":"Register_textField__lvoyX","loginBox":"Register_loginBox__1yKKd"};